/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PracticeBaseService } from '../practice-base-service';
import { PracticeApiConfiguration } from '../practice-api-configuration';
import { PracticeStrictHttpResponse } from '../practice-strict-http-response';

import { patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet } from '../fn/patient-treatment-queue/patient-treatment-queue-clinic-group-id-clinic-treatment-queues-get';
import { PatientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-clinic-group-id-clinic-treatment-queues-get';
import { patientTreatmentQueueEncounterIdByEncounterGet } from '../fn/patient-treatment-queue/patient-treatment-queue-encounter-id-by-encounter-get';
import { PatientTreatmentQueueEncounterIdByEncounterGet$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-encounter-id-by-encounter-get';
import { patientTreatmentQueueIdDeletePost } from '../fn/patient-treatment-queue/patient-treatment-queue-id-delete-post';
import { PatientTreatmentQueueIdDeletePost$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-id-delete-post';
import { patientTreatmentQueueIdGet } from '../fn/patient-treatment-queue/patient-treatment-queue-id-get';
import { PatientTreatmentQueueIdGet$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-id-get';
import { patientTreatmentQueueIdUpdateEncounterEncounterIdPost } from '../fn/patient-treatment-queue/patient-treatment-queue-id-update-encounter-encounter-id-post';
import { PatientTreatmentQueueIdUpdateEncounterEncounterIdPost$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-id-update-encounter-encounter-id-post';
import { patientTreatmentQueueIdUpdateStatusStatusPost } from '../fn/patient-treatment-queue/patient-treatment-queue-id-update-status-status-post';
import { PatientTreatmentQueueIdUpdateStatusStatusPost$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-id-update-status-status-post';
import { PatientTreatmentQueueListItemModel } from '../models/patient-treatment-queue-list-item-model';
import { PatientTreatmentQueueModel } from '../models/patient-treatment-queue-model';
import { patientTreatmentQueuePatientIdHasQueuedGet } from '../fn/patient-treatment-queue/patient-treatment-queue-patient-id-has-queued-get';
import { PatientTreatmentQueuePatientIdHasQueuedGet$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-patient-id-has-queued-get';
import { patientTreatmentQueuePatientIdQueuedGet } from '../fn/patient-treatment-queue/patient-treatment-queue-patient-id-queued-get';
import { PatientTreatmentQueuePatientIdQueuedGet$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-patient-id-queued-get';
import { patientTreatmentQueuePatientIdTreatmentQueuesGet } from '../fn/patient-treatment-queue/patient-treatment-queue-patient-id-treatment-queues-get';
import { PatientTreatmentQueuePatientIdTreatmentQueuesGet$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-patient-id-treatment-queues-get';
import { patientTreatmentQueuePatientTreatmentQueuePost } from '../fn/patient-treatment-queue/patient-treatment-queue-patient-treatment-queue-post';
import { PatientTreatmentQueuePatientTreatmentQueuePost$Params } from '../fn/patient-treatment-queue/patient-treatment-queue-patient-treatment-queue-post';

@Injectable({ providedIn: 'root' })
export class PracticePatientTreatmentQueueService extends PracticeBaseService {
  constructor(config: PracticeApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patientTreatmentQueueIdGet()` */
  static readonly PatientTreatmentQueueIdGetPath = '/PatientTreatmentQueue/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueueIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueIdGet$Response(params: PatientTreatmentQueueIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientTreatmentQueueModel>> {
    const obs = patientTreatmentQueueIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueueIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueIdGet(params: PatientTreatmentQueueIdGet$Params, context?: HttpContext): Observable<PatientTreatmentQueueModel> {
    const resp = this.patientTreatmentQueueIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientTreatmentQueueModel>): PatientTreatmentQueueModel => r.body)
    );
  }

  /** Path part for operation `patientTreatmentQueuePatientTreatmentQueuePost()` */
  static readonly PatientTreatmentQueuePatientTreatmentQueuePostPath = '/PatientTreatmentQueue/PatientTreatmentQueue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueuePatientTreatmentQueuePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientTreatmentQueuePatientTreatmentQueuePost$Response(params?: PatientTreatmentQueuePatientTreatmentQueuePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = patientTreatmentQueuePatientTreatmentQueuePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueuePatientTreatmentQueuePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patientTreatmentQueuePatientTreatmentQueuePost(params?: PatientTreatmentQueuePatientTreatmentQueuePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.patientTreatmentQueuePatientTreatmentQueuePost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patientTreatmentQueuePatientIdTreatmentQueuesGet()` */
  static readonly PatientTreatmentQueuePatientIdTreatmentQueuesGetPath = '/PatientTreatmentQueue/{patientId}/TreatmentQueues';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueuePatientIdTreatmentQueuesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueuePatientIdTreatmentQueuesGet$Response(params: PatientTreatmentQueuePatientIdTreatmentQueuesGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PatientTreatmentQueueListItemModel>>> {
    const obs = patientTreatmentQueuePatientIdTreatmentQueuesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueuePatientIdTreatmentQueuesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueuePatientIdTreatmentQueuesGet(params: PatientTreatmentQueuePatientIdTreatmentQueuesGet$Params, context?: HttpContext): Observable<Array<PatientTreatmentQueueListItemModel>> {
    const resp = this.patientTreatmentQueuePatientIdTreatmentQueuesGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<PatientTreatmentQueueListItemModel>>): Array<PatientTreatmentQueueListItemModel> => r.body)
    );
  }

  /** Path part for operation `patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet()` */
  static readonly PatientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGetPath = '/PatientTreatmentQueue/{clinicGroupId}/ClinicTreatmentQueues';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet$Response(params: PatientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PatientTreatmentQueueListItemModel>>> {
    const obs = patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet(params: PatientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet$Params, context?: HttpContext): Observable<Array<PatientTreatmentQueueListItemModel>> {
    const resp = this.patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<PatientTreatmentQueueListItemModel>>): Array<PatientTreatmentQueueListItemModel> => r.body)
    );
  }

  /** Path part for operation `patientTreatmentQueueEncounterIdByEncounterGet()` */
  static readonly PatientTreatmentQueueEncounterIdByEncounterGetPath = '/PatientTreatmentQueue/{encounterId}/ByEncounter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueueEncounterIdByEncounterGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueEncounterIdByEncounterGet$Response(params: PatientTreatmentQueueEncounterIdByEncounterGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientTreatmentQueueModel>> {
    const obs = patientTreatmentQueueEncounterIdByEncounterGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueueEncounterIdByEncounterGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueEncounterIdByEncounterGet(params: PatientTreatmentQueueEncounterIdByEncounterGet$Params, context?: HttpContext): Observable<PatientTreatmentQueueModel> {
    const resp = this.patientTreatmentQueueEncounterIdByEncounterGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientTreatmentQueueModel>): PatientTreatmentQueueModel => r.body)
    );
  }

  /** Path part for operation `patientTreatmentQueuePatientIdHasQueuedGet()` */
  static readonly PatientTreatmentQueuePatientIdHasQueuedGetPath = '/PatientTreatmentQueue/{patientId}/HasQueued';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueuePatientIdHasQueuedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueuePatientIdHasQueuedGet$Response(params: PatientTreatmentQueuePatientIdHasQueuedGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<boolean>> {
    const obs = patientTreatmentQueuePatientIdHasQueuedGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueuePatientIdHasQueuedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueuePatientIdHasQueuedGet(params: PatientTreatmentQueuePatientIdHasQueuedGet$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.patientTreatmentQueuePatientIdHasQueuedGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `patientTreatmentQueuePatientIdQueuedGet()` */
  static readonly PatientTreatmentQueuePatientIdQueuedGetPath = '/PatientTreatmentQueue/{patientId}/Queued';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueuePatientIdQueuedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueuePatientIdQueuedGet$Response(params: PatientTreatmentQueuePatientIdQueuedGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientTreatmentQueueModel>> {
    const obs = patientTreatmentQueuePatientIdQueuedGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueuePatientIdQueuedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueuePatientIdQueuedGet(params: PatientTreatmentQueuePatientIdQueuedGet$Params, context?: HttpContext): Observable<PatientTreatmentQueueModel> {
    const resp = this.patientTreatmentQueuePatientIdQueuedGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PatientTreatmentQueueModel>): PatientTreatmentQueueModel => r.body)
    );
  }

  /** Path part for operation `patientTreatmentQueueIdUpdateStatusStatusPost()` */
  static readonly PatientTreatmentQueueIdUpdateStatusStatusPostPath = '/PatientTreatmentQueue/{id}/UpdateStatus/{status}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueueIdUpdateStatusStatusPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueIdUpdateStatusStatusPost$Response(params: PatientTreatmentQueueIdUpdateStatusStatusPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = patientTreatmentQueueIdUpdateStatusStatusPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueueIdUpdateStatusStatusPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueIdUpdateStatusStatusPost(params: PatientTreatmentQueueIdUpdateStatusStatusPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.patientTreatmentQueueIdUpdateStatusStatusPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patientTreatmentQueueIdDeletePost()` */
  static readonly PatientTreatmentQueueIdDeletePostPath = '/PatientTreatmentQueue/{id}/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueueIdDeletePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueIdDeletePost$Response(params: PatientTreatmentQueueIdDeletePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = patientTreatmentQueueIdDeletePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueueIdDeletePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueIdDeletePost(params: PatientTreatmentQueueIdDeletePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.patientTreatmentQueueIdDeletePost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patientTreatmentQueueIdUpdateEncounterEncounterIdPost()` */
  static readonly PatientTreatmentQueueIdUpdateEncounterEncounterIdPostPath = '/PatientTreatmentQueue/{id}/UpdateEncounter/{encounterId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientTreatmentQueueIdUpdateEncounterEncounterIdPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueIdUpdateEncounterEncounterIdPost$Response(params: PatientTreatmentQueueIdUpdateEncounterEncounterIdPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = patientTreatmentQueueIdUpdateEncounterEncounterIdPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientTreatmentQueueIdUpdateEncounterEncounterIdPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientTreatmentQueueIdUpdateEncounterEncounterIdPost(params: PatientTreatmentQueueIdUpdateEncounterEncounterIdPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.patientTreatmentQueueIdUpdateEncounterEncounterIdPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

}
